import React, { useEffect } from "react";
import BannerComponent from "../components/banner/BannerComponent";
import TopCategoriesComponent from "../components/topCategories/TopCategoriesComponent";
import TopProductsComponent from "../components/topProducts/TopProductsComponent";
import CategoryList from "../components/categoryList/CategoryList";
import AdvertiseCardSlider from "../components/advertiseCardSlider/AdvertiseCardSlider";
import { useDispatch } from "react-redux";
import { resetSelectedProduct } from "../State/actions/productActions";
import { resetOrderList } from "../State/actions/OrderActions";
import {
  resetProducts,
  resetTotalProducts,
} from "../State/actions/ProductActionsNew";
import Cookies from "js-cookie";
import useUpdateSettings from "../hooks/useUpdateSettings";
import useResponsive from "../hooks/useResponsive";

const HomePage = ({
  showProductQuickViewModal,
  showTrendingQuickView,
  triggerQuickViewModal,
  setloadingOnProductQuickPage,
  loadingOnProductQuickPage,
  setshowHideLoginForm,
  showHideLoginForm,
  relatedDiv,
  setRelatedDiv,
  showBestQuickView,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const dispatch = useDispatch();

  // UseEffect for reset selected Product actions...
  useEffect(() => {
    dispatch(resetSelectedProduct());
    dispatch(resetProducts());
    dispatch(resetTotalProducts());
  }, []);

  // Reset Order List
  useEffect(() => {
    if (!Cookies.get("ID")) {
      dispatch(resetOrderList());
    }
  });

  const MemoizedBannerComponent = React.memo(BannerComponent);
  const MemoizedAdvertiseCardSlider = React.memo(AdvertiseCardSlider);
  const MemoizedCategoryList = React.memo(CategoryList);
  const MemoizedTopCategoriesComponent = React.memo(TopCategoriesComponent);

  const { settingsData } = useUpdateSettings();

  const showBestSellingDataFilter =
    settingsData &&
    settingsData?.filter((data) => data.type === "showbestseller");

  const showTrendingDataFilter =
    settingsData &&
    settingsData?.filter((data) => data.type === "showTrending");

  const showTopCategoriesDataFilter =
    settingsData &&
    settingsData?.filter((data) => data.type === "showtopcategories");

  const isMobile = useResponsive();

  return (
    <>
      {isMobile ? (
        <main>
          <MemoizedBannerComponent />
          {showBestSellingDataFilter[0]?.value === "1" && (
            <TopProductsComponent
              id="BestComponent"
              title="Best Seller"
              productType="bestselling"
              showProductQuickViewModal={showProductQuickViewModal}
              showBestQuickView={showBestQuickView}
              triggerQuickViewModal={triggerQuickViewModal}
              setloadingOnProductQuickPage={setloadingOnProductQuickPage}
              loadingOnProductQuickPage={loadingOnProductQuickPage}
              setshowHideLoginForm={setshowHideLoginForm}
              showHideLoginForm={showHideLoginForm}
              relatedDiv={relatedDiv}
              setRelatedDiv={setRelatedDiv}
            />
          )}
          <MemoizedAdvertiseCardSlider />
          <MemoizedCategoryList />
          {showTrendingDataFilter[0]?.value === "1" && (
            <TopProductsComponent
              id="TrendingComponent"
              title="Trending"
              productType="trending"
              relatedDiv={relatedDiv}
              setRelatedDiv={setRelatedDiv}
              showHideLoginForm={showHideLoginForm}
              setshowHideLoginForm={setshowHideLoginForm}
              loadingOnProductQuickPage={loadingOnProductQuickPage}
              setloadingOnProductQuickPage={setloadingOnProductQuickPage}
              showProductQuickViewModal={showProductQuickViewModal}
              showTrendingQuickView={showTrendingQuickView}
              triggerQuickViewModal={triggerQuickViewModal}
            />
          )}
          {showTopCategoriesDataFilter[0]?.value === "1" &&
            showTopCategoriesDataFilter?.length > 0 && (
              <MemoizedTopCategoriesComponent />
            )}
        </main>
      ) : (
        <main>
          <MemoizedBannerComponent />
          <MemoizedAdvertiseCardSlider />
          <MemoizedCategoryList />
          {showTrendingDataFilter[0]?.value === "1" && (
            <TopProductsComponent
              id="TrendingComponent"
              title="Trending"
              productType="trending"
              relatedDiv={relatedDiv}
              setRelatedDiv={setRelatedDiv}
              showHideLoginForm={showHideLoginForm}
              setshowHideLoginForm={setshowHideLoginForm}
              loadingOnProductQuickPage={loadingOnProductQuickPage}
              setloadingOnProductQuickPage={setloadingOnProductQuickPage}
              showProductQuickViewModal={showProductQuickViewModal}
              showTrendingQuickView={showTrendingQuickView}
              triggerQuickViewModal={triggerQuickViewModal}
            />
          )}
          {showTopCategoriesDataFilter[0]?.value === "1" &&
            showTopCategoriesDataFilter?.length > 0 && (
              <MemoizedTopCategoriesComponent />
            )}
          {showBestSellingDataFilter[0]?.value === "1" && (
            <TopProductsComponent
              id="BestComponent"
              title="Best Seller"
              productType="bestselling"
              showProductQuickViewModal={showProductQuickViewModal}
              showBestQuickView={showBestQuickView}
              triggerQuickViewModal={triggerQuickViewModal}
              setloadingOnProductQuickPage={setloadingOnProductQuickPage}
              loadingOnProductQuickPage={loadingOnProductQuickPage}
              setshowHideLoginForm={setshowHideLoginForm}
              showHideLoginForm={showHideLoginForm}
              relatedDiv={relatedDiv}
              setRelatedDiv={setRelatedDiv}
            />
          )}
        </main>
      )}
    </>
  );
};

export default HomePage;
